import React, { useState } from "react";
import {
  Box,
  IconButton,
  Typography,
  MenuItem,
  Select,
  TextField,
  Button,
  Paper,
  Chip,
  Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PaymentIcon from "@mui/icons-material/Payment";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import BugReportIcon from "@mui/icons-material/BugReport";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import apilink from "../globals/Baseurls";

export default function ContactUs() {
  const navigate = useNavigate();

  const [queryType, setQueryType] = useState("");
  const [priority, setPriority] = useState("");
  const [message, setMessage] = useState("");

  const queryOptions = [
    { label: "Payments", icon: <PaymentIcon fontSize="small" /> },
    { label: "Subscriptions", icon: <SubscriptionsIcon fontSize="small" /> },
    { label: "App not working", icon: <BugReportIcon fontSize="small" /> },
    { label: "Feature Request", icon: <LightbulbIcon fontSize="small" /> },
    { label: "Other", icon: <HelpOutlineIcon fontSize="small" /> },
  ];

  const priorityColors = {
    Low: "default",
    Medium: "primary",
    High: "warning",
    Urgent: "error",
  };

  const handleSubmit = async () => {
    if (!queryType || !priority || !message) {
      toast.error("Please fill all fields");
      return;
    }

    try {
      const { token } = JSON.parse(localStorage.getItem("userSessionData"));
      await axios.post(
        `${apilink.link}/contact-us`,
        { query_type: queryType, priority, message },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Query submitted successfully!");
      setQueryType("");
      setPriority("");
      setMessage("");
    } catch (err) {
      console.error(err.response?.data || err.message);
      toast.error("Failed to submit query");
    }
  };

  return (
    <Box sx={{ p: 2, bgcolor: "#f4f6fb", minHeight: "100vh" }}>
      {/* 🔙 Back Button */}
      <IconButton
        onClick={() => navigate("/profile")}
        sx={{ bgcolor: "#eee", "&:hover": { bgcolor: "#ddd" }, p: 1.5, mb: 3 }}
      >
        <ArrowBackIcon />
      </IconButton>

      <Typography variant="h5" fontWeight="bold" mb={3}>
        Contact Us
      </Typography>

      {/* Card */}
      <Paper
        sx={{
          p: 3,
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          boxShadow: 2,
        }}
      >
        {/* Query Type */}
        <Box>
          <Typography mb={1} fontWeight="medium">
            Query Type
          </Typography>
          <Select
            fullWidth
            value={queryType}
            onChange={(e) => setQueryType(e.target.value)}
            displayEmpty
          >
            {queryOptions.map((q) => (
              <MenuItem key={q.label} value={q.label}>
                <Stack direction="row" spacing={1} alignItems="center">
                  {q.icon}
                  <span>{q.label}</span>
                </Stack>
              </MenuItem>
            ))}
          </Select>
        </Box>

        {/* Priority */}
        <Box>
          <Typography mb={1} fontWeight="medium">
            Priority
          </Typography>
          <Select
            fullWidth
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            displayEmpty
          >
            {Object.keys(priorityColors).map((p) => (
              <MenuItem key={p} value={p}>
                <Chip
                  label={p}
                  color={priorityColors[p]}
                  size="small"
                  sx={{ fontWeight: "bold" }}
                />
              </MenuItem>
            ))}
          </Select>
        </Box>

        {/* Message */}
        <Box>
          <Typography mb={1} fontWeight="medium">
            Your Query
          </Typography>
          <TextField
            multiline
            rows={5}
            placeholder="Type your message here..."
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Box>

        {/* Submit */}
        <Button variant="contained" sx={{ mt: 2 }} onClick={handleSubmit}>
          Submit
        </Button>
      </Paper>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        pauseOnHover
        draggable
        theme="light"
      />
    </Box>
  );
}
